import { de } from "date-fns/locale";
import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
} from "react";

import cx from "classnames";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner.jsx";

const Results = ({
  serverData,
  hideMobileSummary,
  dictionary = {},
  id,
  showOverlay,
  showFacets,
  showDates,
  resultsWrapperRef,
  filteredSearch,
  query,
  clearQuery,
}) => (
  <div
    className={cx("search__results", {
      "search__results--no-mobile-summaries": hideMobileSummary,
    })}
    id={`${id}-results`}
  >
    {showOverlay && <LoadingSpinner />}
    {!showFacets && (
      <>
        <h2 className="filter-bar__title txt-h3">
          {serverData.totalResults} Results Found
        </h2>
        {query !== null && (
          <span className="search__query-pill">
            Search term: {query}{" "}
            <i className="fas fa-times" onClick={() => clearQuery()} />
          </span>
        )}
      </>
    )}
    <div aria-live="polite" className="u-visuallyhidden">
      {!showOverlay && (
        <span>{dictionary.newResultsMessage || "New Results"}</span>
      )}
    </div>
    <div className="js-results-wrapper-ref" ref={resultsWrapperRef}>
      {serverData.results &&
        serverData.results.map((result, i) => (
          <article
            className="search-result"
            key={`search-result-${i}-${result.key}`}
          >
            <h2 className="search-result__title" id={result.id}>
              <a href={result.contentUrl} ref={result.focusRef}>
                {result.title}
              </a>
            </h2>
            {filteredSearch &&
              ((result.date && showDates) ||
                (result.authors && result.authors.length > 0)) && (
                <div className="search-result__meta">
                  {result.date && showDates && (
                    <div className="search-result__date">
                      {new Date(result.date).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "2-digit",
                      })}
                    </div>
                  )}
                  {result.date &&
                    result.authors &&
                    result.authors.length > 0 && <> | </>}
                  {result.authors && (
                    <div className="search-result__author">
                      {result.authors.map(author => author).join(", ")}
                    </div>
                  )}
                </div>
              )}
            {result.body && (
              <div
                className="search-result__description"
                dangerouslySetInnerHTML={{
                  __html: result.body,
                }}
              />
            )}
            {(result.contentType || result.location) && !filteredSearch && (
              <div className="search-result__meta">
                {result.contentType && (
                  <div className="search-result__document-type">
                    Document Type:{" "}
                    <span className="bold">{result.contentType}</span>
                  </div>
                )}
                {result.contentType && result.location && (
                  <div className="search-result__meta-separator">|</div>
                )}
                {result.location && (
                  <div className="search-result__states">
                    Location:{" "}
                    <span
                      className="bold"
                      dangerouslySetInnerHTML={{
                        __html: result.location,
                      }}
                    />
                  </div>
                )}
              </div>
            )}
            {!!result.authors?.length && !filteredSearch && (
              <div className="list-item__meta">
                <span className="list-item__byline">
                  by{" "}
                  {result.authors.map((author, i) => {
                    if (i === result.authors.length - 1) {
                      return <strong key={i}>{author}</strong>;
                    } else {
                      return <strong key={i}>{author}, </strong>;
                    }
                  })}
                </span>
              </div>
            )}
          </article>
        ))}
    </div>
  </div>
);

export default Results;
